import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { Link } from "@inertiajs/react"
import { IconLayoutKanban, IconPlus } from "@tabler/icons-react"
import { useState } from "react"
import type { Navigation } from "../types"
import { NewBoardDialog } from "./NewBoardDialog"

export function BoardNavigator({ navigation }: { navigation: Navigation }) {
  const { boards, active_board_key, can_create, projects } = navigation
  const [creating, setCreating] = useState(false)

  return (
    <>
      <aside aria-label="Boards" className="bg-sidebar hidden w-64 shrink-0 overflow-y-auto border-r p-3 lg:block">
        {can_create && (
          <Button variant="outline" size="sm" className="mb-3 w-full" onClick={() => setCreating(true)}>
            <IconPlus className="size-4" />
            New board
          </Button>
        )}

        <p className="text-muted-foreground px-2 pb-1 text-xs font-medium uppercase tracking-wide">Boards</p>

        {boards.length === 0 ? (
          <p className="text-muted-foreground px-2 py-1 text-sm">No boards yet.</p>
        ) : (
          <ul>
            {boards.map((board) => (
              <li key={board.key}>
                <Link
                  href={`/boards/${board.key}`}
                  className={cn(
                    "hover:bg-accent flex items-center gap-2 rounded-md px-2 py-1.5 text-sm",
                    board.key === active_board_key && "bg-accent font-medium",
                  )}
                >
                  <IconLayoutKanban className="text-muted-foreground size-3.5 shrink-0" />
                  <span className="truncate">{board.name}</span>
                  <span className="text-muted-foreground ml-auto font-mono text-[10px]">{board.key}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </aside>

      <NewBoardDialog open={creating} onOpenChange={setCreating} projects={projects} />
    </>
  )
}
